import { render, staticRenderFns } from "./question.vue?vue&type=template&id=d8a70014&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=d8a70014&prod&lang=css&"
import style1 from "./question.vue?vue&type=style&index=1&id=d8a70014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a70014",
  null
  
)

export default component.exports